import React from "react";
import { IconButton } from "@chakra-ui/react";

/**
 * MiniIconButton — the 25px square row-action button (edit / archive / etc.).
 * Template ref: `.mini`. Pass `colorScheme="red"`/`color="portal.danger"` for
 * destructive actions; all standard Chakra IconButton props pass through.
 */
const MiniIconButton = React.forwardRef(({ sx, ...props }, ref) => (
  <IconButton
    ref={ref}
    variant="outline"
    boxSize="25px"
    minW="25px"
    h="25px"
    w="25px"
    borderRadius="10px"
    borderColor="portal.line"
    bg="white"
    color="#365061"
    fontSize="12px"
    _hover={{ bg: "portal.active", borderColor: "portal.primary", color: "portal.primary" }}
    sx={{ "& svg": { width: "13px", height: "13px" }, ...sx }}
    {...props}
  />
));

MiniIconButton.displayName = "MiniIconButton";

export default MiniIconButton;
